module.exports = __webpack_public_path__ + "img/back.067a47b0.svg";